// extracted by mini-css-extract-plugin
module.exports = {"divider":"ArrowDivider_divider__5y6eJ","line":"ArrowDivider_line__V_Wez","arrowLeftIcon":"ArrowDivider_arrowLeftIcon__OcGrA","arrowRightIcon":"ArrowDivider_arrowRightIcon__9UEJ7"};